/*import home from '../components/homeComponents/home.vue';*/
//import home2 from '../components/homeComponents/home2.vue';
/*import review from '../components/reviewComponent/review.vue';*/
import login from '../components/userComponents/login/login.vue';
//import register from '../components/userComponents/register/register.vue';
//import forgetPassword from '../components/userComponents/forgetPassword/forgetPassword.vue';
import notFound from '../components/errorComponents/notFound.vue';
//import filter from '../components/filterComponents/filters.vue';
//import product from '../components/productComponents/product.vue';
import profile from '../components/profileComponent/profile.vue';
import survey from '../components/surveyComponent/survey.vue';
/*import info from '../components/profileComponent/info.vue';*/
//import customerReviews from '../components/profileComponent/reviews/customerReviews.vue';
import eduDrvSessions from '../components/profileComponent/eduDrvSessions/eduDrvSessions.vue';
/*import credit from '../components/profileComponent/credit.vue';*/
/*import changePassword from '../components/profileComponent/changePassword.vue';*/
/*import orders from '../components/profileComponent/orders/orders.vue';*/
import educatorAndCars from '../components/profileComponent/educatorAndCars.vue';
//import connection_training from '../components/profileComponent/connection_training.vue'
//import addresses from '../components/profileComponent/address/addresses.vue';
//import cart from '../components/cartComponents/cart.vue';
//import chooseAddress from '../components/addressComponents/chooseAddress.vue';
import webServiceError from '../components/errorComponents/webServiceError.vue';
//import invoice from '../components/invoiceComponent/invoice.vue';
//import orderTracking from '../components/orderTrackingComponent/orderTracking.vue'; 
//import compareProduct from '../components/compareProductComponent/compareProduct.vue';
//import content from '../components/contentComponents/content.vue';
//import contactUs from '../components/contactUsComponent/contactUs.vue';
//import aboutUs from '../components/contentComponents/aboutUs.vue';
//import siteGuide from '../components/contentComponents/siteGuide.vue';
/*import customerInquiry from '../components/customerInquiry/customerInquiry.vue';*/
//import rules from '../components/contentComponents/rules.vue';
//import privacy from '../components/contentComponents/privacy.vue';
export const routes = [

    { path: '/', component: login },
/*    { name: 'customerInquiry', path: '/customerInquiry/:id', component: customerInquiry },*/
 
    //{ path: '/register', component: register },
    //{ path: '/contactUs', component: contactUs },
    //{ path: '/forgetPassword', component: forgetPassword },
    //{ name: 'filter', path: '/filter', component: filter },
    //{ path: '/cart', component: cart },
    //{ path: '/invoice', component: invoice },
    //{ name: 'orderTracking' ,  path: '/orderTracking/:hashOrderId', component: orderTracking },
    //{ path: '/chooseAddress', component: chooseAddress },
    //{ name: 'product', path: '/product/:productId/:productName', component: product },
    //{ name: 'review', path: '/review/:productId', component: review },
    { name: 'survey', path: '/survey/:surveyKey', component: survey },
    {
        path: '/profile', component: profile,
        children: [
            // { name: 'info', path: '/info', component: info },
            //{ name: 'credit', path: '/credit', component: credit },
            //{ name: 'orders', path: '/orders', component: orders },
            //{ name: 'connection_training', path: '/connection_training', component: connection_training },
            { name: 'eduDrvSessions', path: '/eduDrvSessions', component: eduDrvSessions },
            { name: 'educatorAndCars', path: '/educatorAndCars', component: educatorAndCars },
            //{ name: 'changePassword', path: '/changePassword', component: changePassword },
            // { name: 'addresses', path: '/addresses', component: addresses },
        ]
    }, 
    //{
    //    name: 'content', path: '/content', component: content,
    //    children: [
    //        { name: 'aboutUs', path: '/aboutUs', component: aboutUs },
    //        { name: 'rules', path: '/rules', component: rules },
    //        { name: 'privacy', path: '/privacy', component: privacy },
    //        { name: 'siteGuide', path: '/siteGuide', component: siteGuide },
    //        { name: 'commonGuestions', path: '/commonGuestions', component: commonGuestions },
    //    ]
    //},
    { path: '/webServiceError', component: webServiceError },

    { path: '*', component: notFound },
]




